// extracted by mini-css-extract-plugin
export var icon = "wrapPageElement-module--icon--26b0c";
export var overlay = "wrapPageElement-module--overlay--45054";
export var overlayHidden = "wrapPageElement-module--overlayHidden--b894b";